
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_x7peu_132gz_93",
  "resizer": "awsui_resizer_x7peu_132gz_98",
  "resizer-active": "awsui_resizer-active_x7peu_132gz_114",
  "tracker": "awsui_tracker_x7peu_132gz_124"
};
  